<template>
  <div class="main">
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div class="parent">
          <h1>Please wait while your avatar loads.<br>This should take about a minute.<br>Please do not leave the page.</h1><br>
          <h1>{{ progress }} %</h1>
          <progress class="progress" :value="progress" max="100">{{ progress }}</progress>
          <img class="image" src="../../assets/landing.png" alt="KNOSIS">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import CryptoJS from 'crypto-js'

  export default {
    data () {
      return {
        progress: 0,
        intervalTime: 2000,
        totalSeconds: 0,
        nonce: this.randomNonce,
        digest: this.randomDigest,

        /* Data needed to Authorization string */
        secret_key: 'test_secret_key_eval253498',
        realm: 'Avatar',
        auth_method: "sha256",
        auth_key: "test_api_key_eval253498",
        auth_nonce: '',
        auth_digest: '',

        /* auth_uri must be exactly same as request for algorithm to work */
        auth_uri: '/api/1.2.0/didimo/' + this.$store.getters.didimoKey + '/status',
      }
    },
    methods: {
      goToAvatar() {
        /* Make call to API every 2 seconds to update percentage of upload */
        var handle = setInterval(this.getPercentageUploaded, this.intervalTime)
        /* Stop making calls after a minute */
        setTimeout(function( ) { clearInterval( handle ); }, 60000)
      },
      toAvatar() {
        this.$router.push({path: '/avatar'})
      },
      getPercentageUploaded() {
        /* Call totalTime method here to change the totalSeconds var which calls the Watcher
           which then call the random Nonce and Digest for every call */
        this.totalTime()
        var self = this

        var xhr = new XMLHttpRequest()
        xhr.open('GET', 'https://mydidimo.com/api/1.2.0/didimo/' + this.$store.getters.didimoKey + '/status', true)
        /* Authorization string must take a new Nonce and digest every call */
        var AuthString = 'DidimoDigest '.concat('realm="Avatar",').concat(" ").concat('auth_method="sha256",').concat(" ").concat('auth_key="test_api_key_eval253498",').concat(" ").concat('auth_nonce="'+this.nonce+'",').concat(" ")
        .concat('auth_digest="'+this.digest+'"')
        xhr.setRequestHeader('Authorization', AuthString)
        xhr.setRequestHeader('Accept', '*/*')
        xhr.onreadystatechange = function() {
          /* Get the percent from the response for our progress bar */
          var responseText = JSON.parse(xhr.responseText)
          self.progress = responseText['percent']
        }
        xhr.send(null)
      },
      /* Randomizes each Nonce call after the first randomNonce in computed */
      randomNonceAgain() {
        var possible = 'abcdefghijklmnopqrstuvwxyz0123456789'
        this.nonce = ''
        for (var i = 0; i < 11; i++) {
          this.nonce += possible.charAt(Math.floor(Math.random() * possible.length))
        }
      },
      /* Randomizes each Digest call after the first randomDigest in computed */
      randomDigestAgain() {
        this.digest = ''
        this.digest = CryptoJS.HmacSHA256((CryptoJS.SHA256(this.auth_key + this.secret_key) + CryptoJS.SHA256(this.auth_key + this.nonce + this.auth_uri)), this.secret_key)
      },
      /* This is for the Watcher to determine when to change the Nonce and Digest */
      totalTime() {
        var seconds = this.totalSeconds + this.intervalTime
        this.totalSeconds = seconds
      },
    },
    mounted() {
      /* Gets the initial Nonce and Digest */
      this.randomNonceAgain()
      this.randomDigestAgain()

      /* Once mounted, start making the API calls */
      this.goToAvatar()
    },
    computed: {
      /* Randomizes each Nonce for first call using Authorization header */
      randomNonce() {
        var text = ""
        var possible = 'abcdefghijklmnopqrstuvwxyz0123456789'
        for (var i = 0; i < 11; i++) {
          text += possible.charAt(Math.floor(Math.random() * possible.length))
        }
        return text
      },
      /* Randomizes each Digest for first call using Authorization header */
      randomDigest() {
        var digest = CryptoJS.HmacSHA256((CryptoJS.SHA256(this.auth_key + this.secret_key) + CryptoJS.SHA256(this.auth_key + this.nonce + this.auth_uri)), this.secret_key)
        return digest
      },
    },
    watch: {
      /* Once the totalSeconds changes, update the nonce and the digest for each new call to API */
      totalSeconds: function(val) {
        this.randomNonceAgain()
        this.randomDigestAgain()
      },
      /* Watches until the progress bar gets to 100% and then reloads the Avatar page */
      progress: function(val, oldVal) {
        if (val == 100) {
          setTimeout(this.toAvatar, 2000)
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

h1 {
  color: purple;
  font-size: 32px;
  position: relative;
  margin: 0 auto;
  text-align: center;
}
.main {
  height: 102%;
  background-color: black;
  background-size: cover;
  background-attachment: scroll;
}
.parent {
  position: relative;
  width: 500px;
  margin: 0 auto;
}
.image {
  width: 620px;
  position: relative;
  margin: 0 auto;
}
@media only screen and (max-width: 625px) {
  .main {
    width: 100vw;
    min-height: 100%;
    background-color: black;
    background-size: cover;
    background-attachment: scroll;
  }
  .parent {
    position: relative;
    width: 100vw;
    height: 100%;
    margin: 0 auto;
  }
  .image {
    width: 310px;
    position: relative;
    margin: 0 auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Avatar/loaderModal.vue